import loading from "@/utils/loading";

//引入登录拦截
import store from "@/store";

import url from '@/utils/url'
//定义前端url前缀
const feUrl = url.feUrl;

//路由拦截
import router from "@/router";
router.beforeEach((to, from, next) => {
    if (to.meta.loading === undefined || to.meta.loading){
        loading.show();
    }
    if(to.meta.w_title) {
        document.title = to.meta.w_title
    }
    if (to.meta.require) {
        if (store.state.username ) {
                // console.log('111111111')
            next()
        } else {
            next({
                path: feUrl + '/login.html?',
                query: {redirect: to.fullPath}
            })
        }
    } else {
        next()
    }
    if (to.meta.loading === undefined || to.meta.loading){
        //关闭loading层
        loading.close();
    }
})
